/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import html2pdf from "html2pdf.js";
import * as XLSX from "xlsx";

import historytab from '../../custom_lib/AiCharts/historytab.vue';
import etmfbarchart from "../../custom_lib/AiCharts/etmfbarchart.vue";
import piechart from "../../custom_lib/AiCharts/etmfPieChart2.vue";
import etmfpiechart from "../../custom_lib/AiCharts/etmfpiechart.vue";
import advtable from "../../custom_lib/AiCharts/advenenttable.vue";
import chartdrill from "../../custom_lib/AiCharts/popupfiles/chartdrillPopup.vue";
import viewAlertDetailsPopup from "../viewAlertDetailsPopup/viewAlertDetailsPopup.vue";
import AlertStatusPopup from "../AlertStatusPopup/AlertStatusPopup.vue";
import store from "../../store";

export default {
  name: "etmfreport",
  components: {
    piechart,
    advtable,
    chartdrill,
    viewAlertDetailsPopup,
    AlertStatusPopup,
    etmfbarchart,
    etmfpiechart,
    historytab
  },
  props: {
    templateId: { type: String, default: "" },
    fromPage: { type: String, default: "" },
  },
  async mounted() {
    window.addEventListener("studyIdChanged", async () => {
      this.studyId = store.getters.getStudyIs;
      await this.getdata();
      this.getallsites();
    });
    await this.getdata();
    this.getallsites();
  },
  data() {
    return {
      // popups + actions
      selectedsite:"",
      sitelist:[],
      alertId: "",
      showAlertStatusPopup: false,
      showAlertDetailsPopup: false,
      drilldata: {},
      drillpopup: false,

      // table data always mirrors current drilled entities (flattened)
      piechartdata: [],

      // table / charts config
      extraicons: ["view", "resolve"],
      columnsinorder: [
        "CreatedAt",
        "SiteCode",
        "SubjectCode",
        "AlertType",
        "Priority",
        "Status",
        "Message",
        "AlertFor",
        "TemplateName",
        "FieldLabel",
        "Value",
        "AlertRule",
        "FieldName",
        "DataSource",
        "Active",
      ],
      piechartcolorcodes: [
         {color: "#ffc486ff", type: "sent"},
        {color: "#62d87eff", type: "QCed"},
        {color: "#46fae8", type: "Reviewed" },
        { color: "#dc3545", type: "Rejected" },
        { color: "#62d87eff", type: "Approved" },
        { color: "#ffc486ff", type: "Pending" },
        { color: "#70b5ffff", type: "Created" },
        { color: "#62d87eff", type: "Completed" },
        { color: "#ffc486ff", type: "In progress" },
      ],
      namesobj: {
        documentName: "Document Name",
        documentTitle: "Document Title",
        artifactName: "Artifact Name",
        versionStatus: "Version Status",
        status: "Status",
        fileName: "File Name",
        version: "Version",
        createdBy: "Created By",
      },
      excludecolumns: [
        "SubjectId",
        "SiteId",
        "Id",
        "StudyId",
        "TemplateId",
        "FormId",
        "AlertMessage",
      ],
      colorcodes: [
        { color: "#E74C3C", type: "Not Resolved" },
        { color: "#4CAF50", type: "Resolved" },
      ],
      custcolors: [
        "#8a2be2",
        "#ABF0FF",
        "#C1D1FF",
        "#FBD164",
        "#FDAD73",
        "#3777B6",
        "#FFD700",
        "#6A5ACD",
        "#00BFFF",
        "#FFA07A",
      ],

      // runtime state
      loader: true,
      maximizedcomp: "",
      data: [],          // current entities (array)
      rootEntities: [],  // full original dataset for "Home"

      // drill history
      historykeys: [],   // ["Home", "versionStatus(...)", ...]
      historydata: {},   // { [crumb]: { entities:[], rows:[] } }

      // misc
      groupchartkeys: { xaxiskey: "LBMETHOD", groupkey: "LBTEST" },
      pieStatusAgg: [],

      // API
      studyId: store.getters.getStudyIs,
      basetestUrl: process.env.VUE_APP_Service_URL,
    };
  },
  methods: {
    async getallsites(){
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.basetestUrl}/management/site/searchlist?StudyID=${this.studyId}&pageindex=1&pagesize=10000&SortProperty=createdAt&SortOrder=1&SiteCode=&SiteName=&Status=`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        this.sitelist = res.data.results;
      } catch (err) { console.log("error in screen list", err); }
    },
    extractEntitiesForDrill(payload) {
      if (Array.isArray(payload)) return payload;
      if (Array.isArray(this.data)) return this.data;
      return [];
    },
    mapEntitiesToRows(entities) {
      var arr = Array.isArray(entities) ? entities : [];
      return arr.map(function(e) {
        var dv = e && e.documentVersion ? e.documentVersion : {};
        var dm = e && e.documentItemMeta ? e.documentItemMeta : {};
        return {
          documentName:  dm && dm.name ? dm.name : "",
          documentTitle: dm && dm.documentTitle ? dm.documentTitle : "",
          artifactName:  dm && dm.artifactName ? dm.artifactName : "",
          versionStatus: dv && dv.versionStatus ? dv.versionStatus : "",
          fileName:      dv && dv.fileName ? dv.fileName : "",
          version:       dv && dv.version ? dv.version : "",
          createdBy:     dv && dv.createdBy ? dv.createdBy : "",
          Type:          dv && dv.versionType ? dv.versionType : "",
        };
      });
    },
    _getEntityFieldValue(entity, field) {
      if (!entity) return undefined;
      if (field === "versionStatus") {
        return entity.documentVersion && entity.documentVersion.versionStatus;
      }
      // you can add more fields here later
      return undefined;
    },
    parseFilterKeyword(filterkeyword) {
      // e.g. "versionStatus(In progress,Created)"
      if (!filterkeyword || typeof filterkeyword !== "string") return null;
      var m = filterkeyword.match(/^([^()]+)\((.*)\)$/);
      if (!m) return null;
      var field = (m[1] || "").trim();
      var vals = (m[2] || "")
        .split(",")
        .map(function (s) { return (s || "").trim(); })
        .filter(function (s) { return !!s; });
      return { field: field, vals: vals };
    },
    // Filter the CURRENT set of entities by a pie/bar “field(values…)” expression.
    filterCurrentByFilterKeyword(filterkeyword) {
      var parsed = this.parseFilterKeyword(filterkeyword);
      if (!parsed) return this.data.slice();
      var field = parsed.field;
      var vals = parsed.vals;

      var set = {};
      for (var i = 0; i < vals.length; i++) {
        set[String(vals[i]).toLowerCase()] = true;
      }
      var src = Array.isArray(this.data) ? this.data : [];
      return src.filter((e) => {
        var v = this._getEntityFieldValue(e, field);
        if (v === undefined || v === null) return false;
        return !!set[String(v).toLowerCase()];
      });
    },

    // ---------- popups ----------
    closeAlertStatusPopup() { this.showAlertStatusPopup = false; },
    openAlertStatusPopup(id) { this.alertId = id; this.showAlertStatusPopup = true; },
    async applychanges(emitteddata) {
      var changedid = emitteddata.id;
      var obj = this.data.find((item) => item.Id === changedid);
      if (obj) {
        obj.Status = "Resolved";
        obj.Comment = emitteddata.comments;
      }
    },
    viewAlertDetails(id) { this.showAlertDetailsPopup = true; this.alertId = id; },
    closeAlertDetailPopup() { this.showAlertDetailsPopup = false; },
    async onclosed() { this.drillpopup = false; },

    // ---------- export ----------
    async exporttoexcell() {
      const worksheet = XLSX.utils.json_to_sheet(this.piechartdata);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "Alert Report.xlsx");
    },
    exportDataPdf() {
      var tableData;
      if (this.fromPage === "studySummary") {
        var filtered = this.piechartdata.map(function (item) {
          var copy = Object.assign({}, item);
          delete copy.FORMID;
          return copy;
        });
        tableData = filtered.reduce(function (acc, cur) {
          var key = String(cur.QUERYID) + "_" + String(cur.STUDYREF);
          if (cur.QUERYID !== null && !acc.some(function (x) {
            return String(x.QUERYID) + "_" + String(x.STUDYREF) === key;
          })) {
            acc.push(cur);
          }
          return acc;
        }, []);
      } else {
        tableData = this.piechartdata;
      }

      const ws = XLSX.utils.json_to_sheet(tableData);
      const html = XLSX.utils.sheet_to_html(ws);

      html2pdf()
        .set({
          margin: 10,
          filename: `Alert Report Data.pdf`,
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "pt", format: "a4", orientation: "landscape" },
        })
        .from(html)
        .save();
    },
    exporttopdf() {
      const container = document.createElement("div");
      const refs = ["captureArea1", "captureArea2", "captureArea3"]
        .map((r) => this.$refs[r])
        .filter(function (n) { return !!n; })
        .map((node) => node.cloneNode(true));

      refs.forEach((el, idx) => {
        if (idx > 0) el.classList.add("page-break");
        el.style.width = "300%";
        container.appendChild(el);
      });

      const opt = {
        margin: 0,
        filename: "Alert Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 4 },
        jsPDF: { unit: "pt", format: "a4", orientation: "landscape" },
      };
      html2pdf().set(opt).from(container).save();
    },

    // ---------- drill / history ----------
    async drillpopupopened() {
      const entities = this.extractEntitiesForDrill(this.data);
      const rows = this.mapEntitiesToRows(entities);
      this.drilldata = rows;
      this.drillpopup = true;
    },

    async drilldowncurrentchart(payload) {
      // fallback (unused by your charts now)
      if (payload && Array.isArray(payload)) {
        this.data = payload.slice();
        this.piechartdata = this.mapEntitiesToRows(this.data);
      }
    },

    async drilldowncurrentchartforbar(payload) {
      // payload: { sortedData, filterkeyword }
      if (!payload || !Array.isArray(payload.sortedData)) return;

      const sorted = payload.sortedData;
      const filterkeyword = payload.filterkeyword || "";

      // shape detection
      const first = sorted[0];
      const isEntity = !!(first && first.documentItemMeta && first.documentVersion);
      const isRow = !!(first && (("documentName" in first) || ("versionStatus" in first)));

      let nextEntities = [];
      if (isEntity) {
        // chart already sent raw entities
        nextEntities = sorted.slice();
      } else if (isRow) {
        // pie sent flattened rows; rebuild by filtering current entities with filterkeyword
        nextEntities = this.filterCurrentByFilterKeyword(filterkeyword);
      } else {
        // unknown, keep current
        nextEntities = Array.isArray(this.data) ? this.data.slice() : [];
      }

      // derive rows for table
      const nextRows = this.mapEntitiesToRows(nextEntities);

      // push history (dedupe by size vs previous)
      const lastKey = this.historykeys.length ? this.historykeys[this.historykeys.length - 1] : null;
      let needPush = true;
      if (lastKey && this.historydata[lastKey] && this.historydata[lastKey].rows) {
        needPush = this.historydata[lastKey].rows.length !== nextRows.length;
      }
      if (filterkeyword && needPush) {
        this.historykeys.push(filterkeyword);
        this.historydata[filterkeyword] = { entities: nextEntities.slice(), rows: nextRows.slice() };
      }

      // update current view + table
      this.data = nextEntities.slice();
      this.piechartdata = nextRows.slice();
    },

    async gotohistorylevel(crumb) {
      if (crumb === "Home") {
        this.historykeys = ["Home"];
        // keep only Home in map
        this.historydata = { Home: this.historydata.Home };
        // restore originals
        this.data = this.rootEntities.slice();
        this.piechartdata = this.mapEntitiesToRows(this.data);
        return;
      }
      // trim history after selected crumb
      this.historydata = this.deleteAfterKeyvaluearrays(crumb);
      this.deleteAfterKeyarrays(crumb);

      // set data from crumb bundle
      const bundle = this.historydata[crumb];
      if (bundle && Array.isArray(bundle.entities)) {
        this.data = bundle.entities.slice();
        this.piechartdata = Array.isArray(bundle.rows)
          ? bundle.rows.slice()
          : this.mapEntitiesToRows(this.data);
      }
    },

    deleteAfterKeyvaluearrays(selectedKey) {
      const entries = Object.entries(this.historydata);
      const idx = entries.findIndex(function (kv) { return kv[0] === selectedKey; });
      const newEntries = idx !== -1 ? entries.slice(0, idx + 1) : entries;
      return Object.fromEntries(newEntries);
    },
    deleteAfterKeyarrays(selectedKey) {
      const index = this.historykeys.indexOf(selectedKey);
      if (index !== -1) this.historykeys = this.historykeys.slice(0, index + 1);
    },
    async sitechanged(){
      if(this.selectedsite == "allsites"){
        await this.getdata();
      }
      else{
        await this.getdata(this.selectedsite);
      }
    },
   

    // ---------- data fetch ----------
    async getdata(sitecode = "") {
      this.loader = true;
      const idtoken = store.getters.getIdToken;
      try {
        const url =
          this.basetestUrl +
          "/etmf/document/getdocumentversionswithdocusign?studyId=" +
          this.studyId +
          "&pageindex=1&pagesize=10000&siteId=" +
          sitecode;

        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });

        // API returns { entities: [...] }
        const entities = Array.isArray(res.data && res.data.entities)
          ? res.data.entities
          : Array.isArray(res.data) ? res.data : [];

        // store originals + current
        this.rootEntities = entities.slice();
        this.data = entities.slice();

        // table = flattened current
        this.piechartdata = this.mapEntitiesToRows(this.data);

        // init history (Home)
        this.historykeys = ["Home"];
        this.historydata = {
          Home: {
            entities: this.rootEntities.slice(),
            rows: this.mapEntitiesToRows(this.rootEntities),
          },
        };

        // optional: quick agg if you still use it anywhere
        const statuses = entities
          .map(function (e) {
            const dv = e && e.documentVersion ? e.documentVersion : {};
            const s = dv.versionStatus;
            return typeof s === "string" ? s.trim() : "";
          })
          .filter(function (v) { return v !== ""; });

        const total = statuses.length;
        const counts = statuses.reduce(function (acc, s) {
          acc[s] = (acc[s] || 0) + 1;
          return acc;
        }, {});
        this.pieStatusAgg = Object.keys(counts).map(function (k) {
          const Count = counts[k];
          const Percent = total ? +( (Count * 100) / total ).toFixed(1) : 0;
          return { versionStatus: k, Count: Count, Percent: Percent };
        });
      } catch (err) {
        console.log("error in screen list", err);
      } finally {
        this.loader = false;
      }
    },

    async pageclosed() {
      this.$router.push(`/etmfdashboard`);
    },
  },
};
